import React from 'react';
import { Image } from '@project-stories/elements/Image/Image';

export const Icon = ({ settings }) => {
  if (!settings) return null;
  
  const {
    icon_source = 'icon_name',
    icon_name = 'star',
    custom_icon,
    icon_size = 24,
    icon_link,
    icon_color,
    alignment = 'left'
  } = settings;
  
  // Get alignment classes
  const getAlignmentClasses = () => {
    switch (alignment) {
      case 'center':
        return 'flex justify-center';
      case 'right':
        return 'flex justify-end';
      case 'left':
      default:
        return 'flex justify-start';
    }
  };

  // Create the icon element based on source type
  const renderIcon = () => {
    if (icon_source === 'icon_name' && icon_name) {
      return (
        <div className={`icon-${icon_name} text-[${icon_size}px] flex-shrink-0`}></div>
      );
    } else if (icon_source === 'custom_image' && custom_icon) {
      return (
        <div className="flex-shrink-0" style={{ width: `${icon_size}px`, height: `${icon_size}px` }}>
          <Image 
            imageUrl={custom_icon} 
            width={icon_size} 
            height={icon_size} 
            alt="Custom icon"
            classes="w-full h-full"
            fit="contain"
          />
        </div>
      );
    }
  };

  const iconContent = (
    <div className={`icon-block-wrapper ${getAlignmentClasses()}`}>
      {renderIcon()}
    </div>
  );

  // Wrap in link if URL is provided
  if (icon_link) {
    return (
      <a href={icon_link} className="icon-block-link transition-opacity inline-block">
        {iconContent}
      </a>
    );
  }

  // Return standalone icon
  return iconContent;
};

export default Icon;